/*
 * � 2020 Microsoft. All rights reserved.
 */

define('CardUI/SupplyView',['lodash',
		'pixi',
		'absolute/audiomanager',
		'Arkadium/GameEngine/Tween/Tween',
		'absolute/debug',
		'absolute/spriteutils',
		'absolute/storagemanager',
		'util/eventhandler',
		'util/dictionary',
		'util/list',
		'Arkadium/GameEngine/Core/EngineManagers',
		'Arkadium/GameEngine/Scenes/Nodes/SpriteNode',
		'SolitaireShared/CardLogic/Pile',
		'SolitaireShared/CardLogic/Card',
		'SolitaireShared/CardLogic/CardOp',
		'CardUI/PileView',
		'CardUI/CardView',
		'CardUI/KeyboardNavigator',
		'CardUI/WinAnimators/KaleidoscopeWinAnimator',
		'CardUI/WinAnimators/ButterflyWinAnimator',
		'CardUI/WinAnimators/FireworksWinAnimator',
		'CardUI/WinAnimators/CardBounceWinAnimator',
		'Solitaire/GameState',
		'util/SettingsManager',
		'util/ThemeManager',
		'Managers/ScaleManager',
		'Managers/AdManager',
		'absolute'
	],
	function (_, PIXI, AudioManager, Tween, Debug, SpriteUtils, StorageManager, EventHandler, Dictionary, List,
	          EngineManagers, SpriteNode, Pile, Card, CardOp, PileView, CardView, KeyboardNavigator,
	          KaleidoscopeWinAnimator, ButterflyWinAnimator, FireworksWinAnimator, CardBounceWinAnimator, GameState,
	          SettingsManager, ThemeManager, ScaleManager, AdManager, Absolute) {

		var SupplyView = function (cardSupply, width, height, game) {
			this.initSupplyView(cardSupply, width, height, game);
		};

		SupplyView.constructor = SupplyView;
		SupplyView.prototype = Object.create(SpriteNode.prototype);

		/// <summary>
		/// Enumeration of possible screen modes
		/// </summary>
		SupplyView.LayoutState =
			{
				HorizontalView: 0,
				VerticalView: 1
			};

		// the internal width and height for the supplyview; it will be scaled to fit in the user's actual resolution
		//SupplyView.InternalWidth = 1600;
		//SupplyView.InternalHeight = 1200;

		SupplyView.AutoMoveInterval = 250;

		SupplyView.prototype.doClassicScaling = function (isNewGame, showAd) {
			this.game.ui.gameScreen.visible = false;
			if (isNewGame) {
				setTimeout(function () {
					for (var i = 0; i < 200; i++) {
						Tween.UpdateAll();
					}
					this.handleResize();
                    setTimeout(function () {
                        this.dealSoundIsAllowed = true;
                        if (window['GD_OPTIONS']) {
                            this.dealSoundIsAllowed = false;
                            AdManager.gameStarted();
                        }
                        else {
                            this.game.solitaire.DealNewGame();
                            this.game.ui.hideLoadingScreen();
                            this.game.ui.loadingScreen.resetLoadingProgress();
                            this.game.ui.gameScreen.visible = true;
                        }
                    }.bind(this), 400);
				}.bind(this), 100);
			} else {
				var resizeInterval = setInterval(function () {
					this.handleResize();
				}.bind(this), 100);
                setTimeout(function () {
					AdManager.gameStarted();
					this.dealSoundIsAllowed = true;
					clearInterval(resizeInterval);
                    this.handleResize();

                    if (!window['GD_OPTIONS'])
                    {
                        this.game.ui.hideLoadingScreen();
                        this.game.ui.loadingScreen.resetLoadingProgress();
                        this.game.ui.gameScreen.visible = true;
                    }
				}.bind(this), 500);
			}
		};

		SupplyView.prototype.doChallengeScaling = function () {
			setTimeout(function () {
				this.alpha = 0;
				this.revealIsRestricted = true;
				for (var i = 0; i < 200; i++) {
					Tween.UpdateAll();
				}
				this.handleResize();
				setTimeout(function () {
					this.revealIsRestricted = false;
					this.dealSoundIsAllowed = true;
					this.game.ui.hideLoadingScreen();
				}.bind(this), 400);
			}.bind(this), 100);
		};

		SupplyView.prototype.initSupplyView = function (cardSupply, width, height, game) {
			SpriteNode.call(this);

			this.InternalWidth = width;
			this.InternalHeight = height;

			this.game = game;
			// A pair of lookups to quickly find the specific PileView for a given pile.
			this._pileFromView = new Dictionary(PileView, Pile);
			this._viewFromPile = new Dictionary(Pile, PileView);
			this._pileViewList = new List();

			this._viewFromCard = new Dictionary(Number, CardView);
			this._cardFromView = new Dictionary(CardView, Card);
			this._cardViewList = new List();

			this._uiKeyboardNavs = null;//new Dictionary(String, KeyboardNavForUIElement);

			this.CardSupply = cardSupply;

			this.OnMoveCardsEvent = new EventHandler();
			this.CardScaleChanged = new EventHandler();
			this.CardsStartDrag = new EventHandler();
			this.CardsStopDrag = new EventHandler();


			this.GameInputInterpreter = null;

			this.AllowInitKeyboardOnLoad = false;

			this.GameContainer = null;

			this._cardScale = 1;
			this._isCardDragging = false;

			this.CurrentLayout = SupplyView.LayoutState.HorizontalView;

			this._getThemeAssetFunc = null;


			this.IsUserTheme = false;


			this.NextWinAnimation = 0;

			this.LocalizedAssetPath = null;

			this._shiftDown = false;


			this.Name = "SupplyView";
			this.KeyboardEnabled = true;
			// These properties are used for graphical optimizations, in certain Solitaire games that don't require some onscreen elements.
			this.EnableHighlight = true;
			this.EnableShadows = true;
			this.EnablePileHints = true;
			this.EnableCardBacks = true;
			this.Layer = -2;

			this.KeyboardFocus = null;
			this.DefaultKeyboardFocus = null;

			this.AutomaticMovesStart = null
			this.AutomaticMovesStop = null;

			this._isAutomaticMovesStarted = false;


			this._timeSinceLastAutoMove = 0;

			this.EndAnimationList = ["KaleidoscopeWinAnimator", "ButterflyWinAnimator", "FireworksWinAnimator", "CardBounceWinAnimator"];
			this._navigatable = false;
			this._focused = false;

			this.NavigationIndex = 0;

			this.ClearHintsCallback = null;

			this.pileBackgroundContainer = new PIXI.DisplayObjectContainer();
			this.addChild(this.pileBackgroundContainer);

			// TODO
			this.Updated = new EventHandler();
			$(window).mouseout(this.handleWindowMouseOut.bind(this));
			this.windowFocusHandler = this.handleWindowFocus.bind(this);
			window.addEventListener("focus", this.windowFocusHandler);
			ScaleManager.addElement(this, {scaleChangeSource: 'Full'});
		};

		SupplyView.prototype.initForceSprite = function () {
			var dimensions = this.getModeSpecificDimensions();
			var graphWidth = dimensions.width, graphHeight = dimensions.height;
			var tempGraphics = new PIXI.Graphics();
			tempGraphics.beginFill(0xff0000, .2);
			tempGraphics.drawRect(0, 0, graphWidth, graphHeight);
			tempGraphics.endFill();
			tempGraphics.beginFill(0x0000ff, .3);
			tempGraphics.drawRect(0, 0, graphWidth, 3);
			tempGraphics.drawRect(0, 0, 3, graphHeight);
			tempGraphics.drawRect(graphWidth - 3, 0, 3, graphHeight);
			tempGraphics.drawRect(0, graphHeight - 3, graphWidth, 3);
			tempGraphics.endFill();
			this.forceSprite = new PIXI.Sprite(tempGraphics.generateTexture());
			this.forceSprite.alpha = 0;
			this.parent.addChild(this.forceSprite);
		};

		SupplyView.prototype.handleForceResize = function () {
			var oldScaleX = this.forceSprite.scale.x, oldScaleY = this.forceSprite.scale.y;
			this.forceSprite.scale.set(1, 1);
			var initialWidth = this.forceSprite.width, initialHeight = this.forceSprite.height;
			this.scale.set(oldScaleX, oldScaleY);
			var screenScaleX = Absolute.Coords.x(1920) / ScaleManager.width,
				screenScaleY = Absolute.Coords.y(1080) / ScaleManager.height,
				roomWidth = ScaleManager.width,
				roomHeight = ScaleManager.height - (this.getHeaderHeight() / screenScaleY);
			this.forceSprite.width = initialWidth * screenScaleX;
			this.forceSprite.height = initialHeight * screenScaleY;
			var realWidth = this.forceSprite.width / screenScaleX,
				realHeight = this.forceSprite.height / screenScaleY;
			var widthToShow = initialWidth, heightToShow = initialHeight, tookCare = false;
			if (realWidth > roomWidth) {
				this.forceSprite.width = Absolute.Coords.x(1920);
				var delta = roomWidth / widthToShow;
				this.forceSprite.height = ((initialHeight * screenScaleY) * delta);
				if ((this.forceSprite.height / screenScaleY) > roomHeight) {
					this.forceSprite.height = Absolute.Coords.y(1080) - this.getHeaderHeight();
					var delta = roomHeight / heightToShow;
					this.forceSprite.width = ((initialWidth * screenScaleX) * delta);
				}
				tookCare = true;
			}
			if (!tookCare && (realHeight > roomHeight)) {
				this.forceSprite.height = Absolute.Coords.y(1080) - this.getHeaderHeight();
				var delta = roomHeight / heightToShow;
				this.forceSprite.width = ((initialWidth * screenScaleX) * delta);
				if ((this.forceSprite.width / screenScaleX) > roomWidth) {
					this.forceSprite.width = Absolute.Coords.x(1920);
					var delta = roomWidth / widthToShow;
					this.forceSprite.height = ((initialHeight * screenScaleY) * delta);
				}
			}
			this.forceSprite.x = Absolute.Coords.x(960) - (this.forceSprite.width / 2);
			this.forceSprite.y = this.getHeaderHeight()
		};

		SupplyView.prototype.handleResize = function () {
			if (this.forceSprite) {
				this.handleForceResize();
				this.scale.set(this.forceSprite.scale.x, this.forceSprite.scale.y);
				this.position.set(this.forceSprite.position.x, this.forceSprite.position.y);
				this.x += this.forceSprite.width / 2;
				this.y += this.forceSprite.height / 2;
				var offset = this.getModeSpecificOffset();
				this.x += offset.x * this.scale.x;
				this.y += offset.y * this.scale.y;
			}
		};

		SupplyView.prototype.getHeaderHeight = function () {
			var yScale = Math.max(Math.min((ScaleManager.height / 1080) + 0.3, 1), 0.7),
				xScale = Math.max(Math.min((ScaleManager.width / 1920) + 0.3, 1), 0.7),
				resizeScale = Math.min(yScale, xScale), height = Absolute.Coords.y(66),
				headerHeight = (resizeScale * (height / ScaleManager.scaleFactorY));
			return headerHeight;
		};

		SupplyView.prototype.handleWindowMouseOut = function () {
			var cards = this.children
				.filter(function (child) {
					return child instanceof PileView;
				}.bind(this))
				.reduce(function (cardsArr, pileView) {
					pileView.children.forEach(function (child) {
						if (child instanceof CardView) {
							cardsArr.push(child);
						}
					});
					return cardsArr;
				}, []);
			cards.forEach(function (c) {
				if (c._isDragging) {
					c.ForceDrop(c.Card.Pile);
				}
			});

		};

		SupplyView.prototype.Register = function (scene) {
			SpriteNode.prototype.Register.call(this, scene);
			_.each(this.Scene.game.menuBar.gameOptionsSlideouts, function (menu) {
				if (menu.config.contentLayout[0] === "GameOptionsChallenge") return;
				menu.onSubMenuToggle.add(this.handleSubMenuToggle.bind(this));
			}.bind(this));
		};

		SupplyView.prototype.handleSubMenuToggle = function (sender, isSubMenuOpen) {
			this.CardSupply.shouldPauseTime = isSubMenuOpen;
		};

		// TODO fix event handlers

		SupplyView.prototype.OnCardScaleChanged = function () {
			var handler = this.CardScaleChanged;
			if (handler != null) handler.handleEvent(this/* TODO , EventArgs.Empty */);
		};

		SupplyView.prototype.OnCardsStartDrag = function () {
			var handler = this.CardsStartDrag;
			if (handler != null) {
				handler.handleEvent(this/* TODO , EventArgs.Empty */);
			}
		};

		SupplyView.prototype.OnCardsStopDrag = function () {
			var handler = this.CardsStopDrag;
			if (handler != null) handler.handleEvent(this /* TODO , EventArgs.Empty */);
		};

		SupplyView.prototype.GetWidth = function () {
			return this.InternalWidth;
		};

		SupplyView.prototype.GetHeight = function () {
			return this.InternalHeight;
		};


		Object.defineProperty(SupplyView.prototype, "CardScale",
			{
				get: function () {
					return this._cardScale;
				},
				set: function (value) {
					// TODO - figure out why spider bg not updating without commenting out this
					//if (Math.abs(this._cardScale - value) > 0)
					//{
					this._cardScale = value;
					this.OnCardScaleChanged();
					//}
				}
			});

		Object.defineProperty(SupplyView.prototype, "IsCardDragging",
			{
				get: function () {
					return this._isCardDragging;
				},
				set: function (value) {
					if (value == this._isCardDragging) {
						return;
					}

					this._isCardDragging = value;
					if (value) {
						this.OnCardsStartDrag();
					} else {
						this.OnCardsStopDrag();
					}
				}
			});

		/// <summary>
		/// Function which retrieves theme assets from the current theme.
		/// </summary>
		Object.defineProperty(SupplyView, "GetThemeAssetFunc",
			{
				set: function (value) {
					this._getThemeAssetFunc = value;
				}
			});


		/// <summary>
		/// Retrieves a theme asset path from the current theme.
		/// </summary>
		/// <param name="assetType">Type of asset to request.</param>
		/// <returns>Returns the retrieved theme asset path.</returns>
		SupplyView.prototype.GetThemeAssetPath = function (assetType) {
			//return this._getThemeAssetFunc(assetType);

			var path = "";
			var theme = ThemeManager.CurrentTheme;

			if (assetType == "cardback" || assetType.length <= 3) {
				path = theme + "/cards/";
			} else {
				switch (assetType) {
					case "shadow":
					case "higlight":
					case "goal_glow":
					case "foundation_effect":
					case "blankpile":
					case "ending_card_glow":
					case "hint_highlight":
						path = "";
						break;
					default:
						path = theme + "/";
				}
			}

			if (assetType == "jo") {
				assetType = "0n"; // TODO check this
			}

			return path + assetType + ".png";
		};

		SupplyView.prototype.GetPileView = function (p) {
			if (typeof p == 'string') {
				p = this.CardSupply.GetPile(p);
			}
			return p && this._viewFromPile.ContainsKey(p) ? this._viewFromPile.Get(p) : null;
		};

		SupplyView.prototype.GetCardView = function (c) {
			if (c == null) return null;
			return this._viewFromCard.ContainsKey(c.Sequence) ? this._viewFromCard.Get(c.Sequence) : null;
		};

		SupplyView.prototype.forceShadowHide = function (state, cards, startCard) {
			var startIndex = cards.indexOf(startCard);
			_.forEach(cards, function (card, index) {
				if (index >= startIndex) {
					var cardView = this.GetCardView(card);
					cardView.forceShadowHide(state);
				}
			}, this);
		};

		SupplyView.prototype.destroy = function () {
			clearInterval(this.pileUpdateInterval);
			clearTimeout(this.pileUpdateTimeout);
			ScaleManager.removeElement(this);
			window.removeEventListener("focus", this.windowFocusHandler);
			this.hasBeenDestroyed = true;
		};

		SupplyView.prototype.Destroy = function () {
			this.OnMoveCardsEvent.remove(this.SupplyView_OnMoveCards);
			this.CardSupply.OnShuffleEvent.remove(this.CardSupply_OnPreDealEvent);
			this.CardSupply.OnDealEvent.remove(this.CardSupply_OnDealEvent);
			this.CardSupply.OnWildCardAddedEvent.remove(this.CardSupply_OnWildCardAdded);

			/*EngineManagers.Input.KeyDown.remove(FocusedStateAction);
			EngineManagers.Input.KeyDown.remove(PressKey);
			EngineManagers.Input.KeyUp.remove(ReleaseKey);*/

			_.forEach(this.children, function (child) {
				if (child instanceof PileView)
					child.UnregisterEvents();
			});
		};

		SupplyView.prototype.SetAllCardsFace = function () {
			_.forEach(this._cardViewList, function (cardView) {
				var pileView = cardView.Parent;
				if (pileView != null) {
					pileView.CardFacing = PileView.Facing.FaceUp;
				}
			});
		};

		SupplyView.prototype.CardSupply_OnWildCardAdded = function (sender) {
			this.UpdatePileChildren(false);
		};

		SupplyView.prototype.OnChangedFocus = function () {
			if (this.KeyboardFocus == null)
				this.KeyboardFocus = this.DefaultKeyboardFocus;

			if (this.Focused)
				this.KeyboardFocus.Keyboard.GetKeyboardFocus();
			else
				this.KeyboardFocus.Keyboard.LoseKeyboardFocus();
		};

		SupplyView.prototype.Init = function (callback) {
			if (!this.HasRunInit) {
				// TODO pass this?
				this.CardSupply.OnShuffleEvent.add(this.CardSupply_OnPreDealEvent.bind(this));

				this.CardSupply.OnWildCardAddedEvent.add(this.CardSupply_OnWildCardAdded.bind(this));

				this.CardSupply.OnDealEvent.add(this.CardSupply_OnDealEvent.bind(this));

				// TODO - event stuff

				this.OnMoveCardsEvent.add(this.SupplyView_OnMoveCards);

				/*
				this.CardSupply.OnWildCardAdded.add(this.CardSupply_OnWildCardAdded);

				if (this.AllowInitKeyboardOnLoad)
				{
					EngineManagers.Input.KeyDown.add(PressKey);
					EngineManagers.Input.KeyUp.add(ReleaseKey);
				}
			   */

				//this.pressKeyReference = this.PressKey.bind(this);

				//this.startListeningForKeyboard();

				SpriteNode.prototype.Init.call(this, callback);
			}
		};

		SupplyView.prototype.CardSupply_OnPreDealEvent = function (sender) {
			this.IsCardDragging = false;
			this.SetupCardViews();
			for (var i = 0; i < this.CardSupply.PileCount; i++) {
				var pile = this.CardSupply.GetPile(i);
				if (pile == null)
					continue;
				this.GetPileView(pile).NotifyDealing();
				this.GetPileView(pile).UpdatePosition();
			}
		};

		SupplyView.prototype.CardSupply_OnDealEvent = function (sender) {
			this.UpdatePileChildren(true);
			this.GameInputInterpreter.ClearHighlight();
			this.playDealSound();
			if (!this.revealIsRestricted) this.alpha = 1;
			this.setUpPileUpdate();
			if (this.CardSupply.Authority.IsChallenge) {
				var hint = this.CardSupply.Authority.GetHint(true);
				this.ClearHints();
				this.DisplayHint(hint);
			}
		};

		SupplyView.prototype.SetupPileViews = function () {
			this.ClearPileLookups();
			this.ClearPileViewChildren();

			// Set up our child nodes: PileViews and CardViews.
			for (var i = 0; i < this.CardSupply.PileCount; i++) {
				var pile = this.CardSupply.GetPile(i);

				if (pile == null)
					continue;

				var pileView = new PileView(pile, this);
				this.AddChild(pileView);

				this.AddPileToLookups(pileView);
			}

			// XXXCBR - force foundations on top -- fixes bug in spider where cards appear below others when animating to stack
			for (var i = 0; i < this.CardSupply.PileCount; i++) {
				var pile = this.CardSupply.GetPile(i);

				if (pile == null)
					continue;

				var pileView = this._viewFromPile.Get(pile);
				if (pile.Type == "Foundation") {
					this.AddChild(pileView);
				}
			}
		};

		SupplyView.prototype.reversePiles = function () {
			var tempList = _.clone(this._pileViewList.items);
			tempList.reverse();
			_.each(tempList, function (pileView) {
				this.AddChild(pileView);
			}.bind(this));
		};

		SupplyView.prototype.undoReversePiles = function () {
			_.each(this._pileViewList.items, function (pileView) {
				this.AddChild(pileView);
			}.bind(this));
		};

		SupplyView.prototype.bringPileAndCardToTop = function (pileView, cardView) {
			this.AddChild(pileView);
			pileView.AddChild(cardView);
		};

		SupplyView.prototype.pileViewToIndex = function (pileView) {
			this.AddChild(pileView);
		};

		SupplyView.prototype.AddKeyboardUIElement = function (name, uiElement, onActivate) {
			var element = new KeyboardNavForUIElement(this, uiElement, onActivate);

			if (_uiKeyboardNavs.ContainsKey(name)) {
				_uiKeyboardNavs[name].TargetElement = uiElement;
				_uiKeyboardNavs[name].OnActivate = onActivate;
			} else {
				_uiKeyboardNavs.Add(name, element);
			}
			/*lock (_uiKeyboardNavs)
			{
				var element = new KeyboardNavForUIElement(this, uiElement, onActivate);

				if (_uiKeyboardNavs.ContainsKey(name))
				{
					_uiKeyboardNavs[name].TargetElement = uiElement;
					_uiKeyboardNavs[name].OnActivate = onActivate;
				}
				else
				{
					_uiKeyboardNavs.Add(name, element);
				}
			}*/
		};

		SupplyView.prototype.RemoveKeyboardUIElement = function (name, uiElement) {
			/*if (_uiKeyboardNavs.ContainsKey(name))
			{
				if (_uiKeyboardNavs[name].TargetElement == uiElement)
				{
					_uiKeyboardNavs[name].TargetElement = null;
					_uiKeyboardNavs[name].OnActivate = null;
				}
			}*/
		};

		SupplyView.prototype.ClearKeyboardUIElements = function () {
			/*lock (_uiKeyboardNavs)
			{
				foreach (var keyboardNav in _uiKeyboardNavs.Values)
				{
					keyboardNav.UnregisterEvents();
				}
				_uiKeyboardNavs.Clear();
			}*/
		};

		SupplyView.prototype.GetKeyboardUI = function (name) {
			/* if (_uiKeyboardNavs.ContainsKey(name))
				 return _uiKeyboardNavs[name];*/
			return null;
		};

		SupplyView.prototype.AddPileToLookups = function (pileView) {
			this._pileFromView.Add(pileView, pileView.Pile);
			this._viewFromPile.Add(pileView.Pile, pileView);
			this._pileViewList.add(pileView);
		};

		SupplyView.prototype.ClearPileLookups = function () {
			this._pileFromView.Clear();
			this._viewFromPile.Clear();
			this._pileViewList.clear();
		};

		SupplyView.prototype.ClearPileViewChildren = function () {

			_.forEach(this.children, function (child) {
					if (child instanceof PileView) {
						child.UnregisterEvents();
						this.RemoveChild(child);
					}
				},
				this);
		}


		SupplyView.prototype.handleCommand = function (command) {
			var key = KeyboardNavigator.KeyPress[command];

			if (typeof key !== 'undefined') {
				if (this.KeyboardFocus == null) {
					this.Focused = true;

					//this.KeyboardFocus = this.DefaultKeyboardFocus;
					if (this.KeyboardFocus != null) {
						if (!this.KeyboardFocus.OnGetKeyboardFocus())
						//if (this.KeyboardFocus.OnGetKeyboardFocus())
						{
							this.KeyboardFocus.Keyboard.HandleKeypress(KeyboardNavigator.KeyPress.Tab);
						}
					}
				} else {
					this.KeyboardFocus.Keyboard.HandleKeypress(key);
				}
				event.preventDefault();
				return false;
			}
		};


		SupplyView.prototype.ReleaseKey = function (keyboardEvent) {
			/*var keyId = keyboardEvent.Key;
			switch (keyId)
			{
				case VirtualKey.Shift:
				{
					_shiftDown = false;
					break;
				}
			}*/
		};

		SupplyView.prototype.SetupCardViews = function () {
			this.ClearCardViewGrandchildren();
			this.ClearCardLookups();

			// Now set up all cards in the supply.
			_.forEach(this.CardSupply.GetCardList(), function (card) {
					var cardView = new CardView(card, this);
					cardView.ScaleX = cardView.ScaleY = this.CardScale;
					this.AddCardToLookups(card, cardView);
				},
				this);
			if (this.Focused) {
				this.Focused = false;
			}
			this.UpdatePileChildren(true);
		};

		SupplyView.prototype.ClearCardViewGrandchildren = function () {
			_.forEach(this.CardSupply.GetCardList(), function (card) {
					if (this._viewFromCard.ContainsKey(card.Sequence)) {
						var cardView = this._viewFromCard.Get(card.Sequence);
						if (cardView.Parent != null) {
							cardView.UnregisterEvents();
							cardView.Parent.RemoveChild(cardView);
						}
					}
				},
				this);
		}

		SupplyView.prototype.AddCardToLookups = function (card, cardView) {
			this._cardFromView.Add(cardView, card);
			this._viewFromCard.Add(card.Sequence, cardView);
			this._cardViewList.add(cardView);
		};

		SupplyView.prototype.ClearCardLookups = function () {
			this._cardFromView.Clear();
			this._viewFromCard.Clear();
			this._cardViewList.clear();
		};

		/// <summary>
		/// Trigger OnMoveCardsEvent to update the visual piles.
		/// </summary>
		SupplyView.prototype.OnMoveCards = function () {
			if (this.OnMoveCardsEvent != null)
				this.OnMoveCardsEvent.handleEvent(this);
		};


		SupplyView.prototype.SupplyView_OnMoveCards = function (supply) {
			supply.UpdatePileChildren(false);
		};


		SupplyView.prototype.OnAutomaticMovesStart = function () {
			if (!this._isAutomaticMovesStarted) {
				this._isAutomaticMovesStarted = true;
				var handler = this.AutomaticMovesStart;
				if (handler != null) handler();
			}
		};

		SupplyView.prototype.OnAutomaticMovesStop = function () {
			if (this._isAutomaticMovesStarted) {
				this._isAutomaticMovesStarted = false;
				var handler = this.AutomaticMovesStop;
				if (handler != null) handler();
			}
		};

		SupplyView.prototype.RunAutomaticMoves = function () {
			if (this.AutomaticMovedUpdatedHandler) return;
			this.AutomaticMovedUpdatedHandler = this.AutomaticMovesUpdated.bind(this);
			this.Updated.add(this.AutomaticMovedUpdatedHandler);
		};


		SupplyView.prototype.AutomaticMovesUpdated = function (sender, gameTime) {
			this._timeSinceLastAutoMove += EngineManagers.Time.ElapsedGameTime.Milliseconds;

			if (this._timeSinceLastAutoMove > SupplyView.AutoMoveInterval) {
				this._timeSinceLastAutoMove = 0;
				var a = this.CardSupply.Authority.GetAutomaticMove();
				if (a != null) {
					this.OnAutomaticMovesStart();
					a.Run();
					EngineManagers.Sounds.PlaySound("foundation");
					this.OnMoveCards();
					if (this.CardSupply.Authority.GetAutomaticMove() === null) {
						this.Updated.remove(this.AutomaticMovedUpdatedHandler);
						this.AutomaticMovedUpdatedHandler = null;
						this.OnAutomaticMovesStop();
					}
				} else {
					this.Updated.remove(this.AutomaticMovedUpdatedHandler);
					this.AutomaticMovedUpdatedHandler = null;
					this.OnAutomaticMovesStop();
				}
			}
		};

		SupplyView.prototype.TellMouseDown = function (view, rightClick, isSingleTap) {
			if (view instanceof PileView) {
				this.TellMouseDownPileView(view);
			} else if (view instanceof CardView) {
				this.TellMouseDownCardView(view, rightClick, isSingleTap);
			}
		};

		SupplyView.prototype.TellMouseDownPileView = function (pileView) {
			// Hide hint glow once player interacts with a card.
			var cardReference = this.GameInputInterpreter.GetHighlightedCard();
			var priorPileType = null;
			if (cardReference != null) {
				priorPileType = cardReference.Card.Pile.Type;
			}
			if (!this.CardSupply.Authority.IsChallenge) {
				this.ClearHints();
			}

			var a = this.GameInputInterpreter.ClickEmptyPile(pileView);
			if (!a.IsError()) {
				if (a.Run() && !a.IsNoop()) {
					this.RunAutomaticMoves();
				}
			}
			this.OnMoveCards();

			if (cardReference != null && priorPileType != "Foundation" && cardReference.Card.Pile.Type == "Foundation") {
				EngineManagers.Sounds.PlaySound("foundation");
			}
		};

		SupplyView.prototype.TellMouseDownCardView = function (cardView, rightClick, isSingleTap) {
			// Hide hint glow once player interacts with a card.

			// TODO - avoid this for daily challenge hints?
			if (!this.CardSupply.Authority.SuppressClearHintsOnMouseDown) {
				this.ClearHints();
			}
			var oldPile = cardView.Card.Pile;

			if (oldPile.Name === "Stock" && this.CardSupply.GameName === "Spider") {
				var pileCards = oldPile.Cards, pileCardViews = [];
				_.each(pileCards, function (e) {
					pileCardViews.push(this._viewFromCard.Get(e.Sequence));
				}.bind(this));
				_.each(pileCardViews, function (e) {
					e.InputIsBlocked = true;
				});
				setTimeout(function () {
					_.each(pileCardViews, function (e) {
						e.InputIsBlocked = false;
					});
				}.bind(this), 1000);
			}

			var a = this.GameInputInterpreter.ClickCard(cardView, rightClick, isSingleTap);
			if (!a.IsError()) {
				this.KeyboardFocus = this.GetPileView(cardView.Card.Pile);

				if (a.IsMove()) cardView.LockMosueUpReveal = true;
				if (a.Run()) {
					// move the keyboard highlight to the left in tripeaks and pyramid
					if (this.KeyboardFocus != null) {
						if (this.KeyboardFocus.Keyboard.Host instanceof PileView) {
							var pile = this.KeyboardFocus.Keyboard.Host;
							if (pile != null && pile.FocusedCard != null && this.GameInputInterpreter.ShouldMoveKeyboard(a, pile.FocusedCard.Card)) {
								this.KeyboardFocus.Keyboard.HandleKeypress(KeyboardNavigator.KeyPress.Left);
							}
						}
					}

					if (oldPile.Name == "Stock" && cardView.Card.Pile.Type != "Stock") {
						if (Math.abs(a.Ops[0].GetNumber(CardOp.eMoveParams.NumCards)) > 1 || a.Ops.length > 2) {
							if (this.CardSupply.GameName == "Spider") {
								EngineManagers.Sounds.StopSound("Deal_Spider_Draw");
								EngineManagers.Sounds.PlaySound("Deal_Spider_Draw");
							} else {
								EngineManagers.Sounds.PlaySound("threeCards");
							}
						} else {
							EngineManagers.Sounds.PlaySound("singleCard");
						}
					}

					if (cardView.Card.Pile != oldPile) {
						cardView.IsDragging = false;
						this.IsCardDragging = false;
					}

					if (!a.IsNoop()) {
						this.RunAutomaticMoves();
					}
				}

				if (!a.isAllowed) {
					this.dealIsNotAllowed();
				}
			}
			this.OnMoveCards();
		};

		SupplyView.prototype.TellMouseUp = function (cardView, forcePile) {

			// TODO UPDATE FOR THIS FUNCTION - get a LIST of piles we're dropping onto, and
			// give the input interpreter ALL intersecting piles to deal with.

			// see if we're on a card or pile to drop onto
			var dropPiles = null;
			if (forcePile == null) {
				var cardPos = this.toGlobal(new PIXI.Point(cardView.X, cardView.Y));
				var cardViewWorldBoundingBox = cardView.CardFront.children.slice().pop().getBounds();
				_.forEach(this._cardViewList.items, function (checkCard) {
					if (checkCard != cardView && checkCard.Card.Pile != cardView.Card.Pile &&
						SpriteUtils.rectsIntersect(checkCard.CardFront.children.slice().pop().getBounds(), cardViewWorldBoundingBox) &&
						this.CardSupply.Authority.CanAcceptCards(checkCard.Card.Pile) &&
						this._viewFromPile.ContainsKey(checkCard.Card.Pile)) {
						if (dropPiles == null)
							dropPiles = new Dictionary(PileView, Number);
						var dropOnPile = this._viewFromPile.Get(checkCard.Card.Pile);

						var dropPoint = this.toGlobal(dropOnPile.x, dropOnPile.y);

						var dist = Math.pow(cardPos.x - dropPoint.x, 2) + Math.pow(cardPos.y - dropPoint.y, 2);
						//Vector3.DistanceSquared(cardPos, ToGlobal(new Vector3(dropOnPile.X, dropOnPile.Y, 0)));

						if (!dropPiles.ContainsKey(dropOnPile))
							dropPiles.Add(dropOnPile, dist);
						else if (dist < dropPiles.Get(dropOnPile))
							dropPiles.Add(dropOnPile, dist);
					}
				}, this);

				_.forEach(this._pileViewList.items, function (pileView) {
					if (pileView.Pile.Empty && pileView.Pile != cardView.Card.Pile &&
						SpriteUtils.rectsIntersect(pileView.Background.getBounds(), cardViewWorldBoundingBox) &&
						this.CardSupply.Authority.CanAcceptCards(pileView.Pile)) {
						if (dropPiles == null)
							dropPiles = new Dictionary(PileView, Number);
						var dropOnPile = pileView;

						var dropPoint = this.toGlobal(dropOnPile.x, dropOnPile.y);
						var dist = Math.pow(cardPos.x - dropPoint.x, 2) + Math.pow(cardPos.y - dropPoint.y, 2);

						//Vector3.DistanceSquared(cardPos, ToGlobal(new Vector3(dropOnPile.X, dropOnPile.Y, 0)));

						if (!dropPiles.ContainsKey(dropOnPile))
							dropPiles.Add(dropOnPile, dist);
						else if (dist < dropPiles.Get(dropOnPile))
							dropPiles.Add(dropOnPile, dist);
					}
				}, this);
			} else // forcePile is not null, so force the drop to be on that pile!
			{
				dropPiles = new Dictionary(PileView, Number);
				//{{forcePile, 0}};
				dropPiles.Add(forcePile, 0);
			}

			if (dropPiles != null) {
				var toSort = dropPiles.GetKeys().map(function (key) {
					return {key: key, value: dropPiles.Get(key)}
				});

				toSort.sort(function (a, b) {
					return a.value.length - b.value.length;
				});

				var sortedPileList = toSort.map(function (current) {
					return current.key
				});

				var a = this.GameInputInterpreter.Drop(cardView, sortedPileList);
				if (!a.IsError()) {
					if (a.Run()) {
						this.RunAutomaticMoves();
					}
				}
			} else {
				if (SettingsManager.getSetting('general', 'singleTapToMove')) {
					if (this.CardSupply.GameName === "Klondike" ||
						this.CardSupply.GameName === "Spider" ||
						this.CardSupply.GameName === "FreeCell") {
						if (!cardView.HasJustBeenMoved) this.doSingleTap(cardView);
					}
				}
				EngineManagers.Sounds.PlaySound("illegalMove");
			}
			this.OnMoveCards();

		};

		/// <summary>
		/// Go through the piles in the supply and make sure each one has the correct children in the correct order.
		/// </summary>
		SupplyView.prototype.UpdatePileChildren = function (setup) {
			// Check for stragglers
			_.forEach(this.CardSupply.GetCardList(), function (card) {
				if (this._viewFromCard.ContainsKey(card.Sequence)) {
					var cardView = this._viewFromCard.Get(card.Sequence);
					if (cardView.Parent != null) {
						cardView.Parent.RemoveChild(cardView);
					}
				}
			}, this);

			// Now go through the piles, and parent each CardView to to the appropriate PileViews depending on
			// which Pile it's in.
			_.forEach(this.CardSupply.GetPileList(), function (pile) {
				if (pile != null) {

					var pileView = this._viewFromPile.Get(pile);

					_.forEach(pile.GetCards(), function (card) {
						try {
							var cardView = this._viewFromCard.Get(card.Sequence);
							pileView.AddChild(cardView);
						} catch (e) {
							Debug.log(e);
						}
					}, this);
				}
			}, this);

		};

		SupplyView.prototype.doSingleTap = function (cardView) {
			var hint = this.CardSupply.Authority.GetCardHint(cardView.Card);
			if (hint) {
				if (hint.Opcode === CardOp.Op.Move) {
					var pileCards = cardView.Card.Pile.Cards,
						pileCardViews = [];
					_.each(pileCards, function (e) {
						pileCardViews.push(this._viewFromCard.Get(e.Sequence));
					}.bind(this));
					var dest = hint.GetPile(CardOp.eMoveParams.DestPile),
						destView = this.GetPileView(dest);
					if (dest.Empty) {
						this.TellMouseDown(destView, false, true);
					} else {
						this.TellMouseDown(this.GetCardView(dest.Top), false, true);
					}
					this.GameInputInterpreter.ClickOutside();
					_.each(pileCardViews, function (e) {
						e.InputIsBlocked = true;
					});
					setTimeout(function () {
						_.each(pileCardViews, function (e) {
							e.InputIsBlocked = false;
						});
					}, 300);
				}
			} else {
				var pile = cardView.Card.Pile,
					cardNum = pile.GetCardPosFromEnd(cardView.Card),
					travelingCards = [];
				for (var i = cardNum; i > 0; i--) {
					travelingCards.push(this._viewFromCard.Get(pile.NthFromTop(i).Sequence));
				}
				_.each(travelingCards, function (e) {
					e.InputIsBlocked = true;
				});
				this.GameInputInterpreter.ClickOutside();
				setTimeout(function () {
					_.each(travelingCards, function (e) {
						e.AnimateSingleTapRejection();
					});
					setTimeout(function () {
						_.each(travelingCards, function (e) {
							e.InputIsBlocked = false;
						});
					}, 200);
				}, 100);
			}
		};


		SupplyView.prototype.DisplayHint = function (hintOperation) {
			if (hintOperation == null || hintOperation.Opcode == CardOp.Op.Noop)
				return;

			if (hintOperation.Opcode == CardOp.Op.Challenge) {
				this.ClearHints();
				for (var i = 0; i < hintOperation.GetNumParams(); ++i) {
					var card = hintOperation.GetCard(i);
					this._viewFromCard.Get(card).IsGoalGlow = true;
				}
				return;
			}

			var source = hintOperation.GetPile(CardOp.eMoveParams.SourcePile);
			var destination = hintOperation.GetPile(CardOp.eMoveParams.DestPile);
			var numCards = hintOperation.GetNumber(CardOp.eMoveParams.NumCards);

			if (!source.Empty) {
				for (var i = 0; i < numCards; i++)
					this._viewFromCard.Get(source.GetCardAtPos(source.Count - i - 1).Sequence).IsHinted = true;
			} else {
				this._viewFromPile.Get(source).IsHinted = true;
			}

			// Also highlight the destination if we're moving to a tableau.
			if (!destination.Empty)
				this._viewFromCard.Get(destination.Top.Sequence).IsHinted = true;
			else
				this._viewFromPile.Get(destination).IsHinted = true;
		};


		SupplyView.prototype.dealIsNotAllowed = function () {
			var piles = this.CardSupply.Authority.GetEmptyColumns();
			piles.forEach(function (pile) {
				this.GetPileView(pile).dealIsNotAllowed();
			}.bind(this))
		};

		SupplyView.prototype.ClearKeyboardHighlight = function () {
			_.forEach(this._viewFromPile.GetValues(), function (pileView) {
				pileView.Keyboard.HasKeyboardFocus = false;
			});
		};

		SupplyView.prototype.ClearHints = function () {
			_.forEach(this._viewFromCard.GetValues(), function (cardView) {
				cardView.IsHinted = false;
				cardView.IsGoalGlow = false;
			});

			_.forEach(this._viewFromPile.GetValues(), function (pileView) {
				pileView.IsHinted = false;
			});

			if (this.ClearHintsCallback != null) {
				this.ClearHintsCallback();
			}
		};

		SupplyView.prototype.ClearRevealCardStates = function (cardViewInstead) {
			_.forEach(this._viewFromCard.GetValues(), function (cardView) {
				if (cardView != cardViewInstead) {
					cardView.IsRevealToShow = false;
				}
			});
		};

		SupplyView.prototype.LockMousUpRevealCard = function (isLock) {
			_.forEach(this._viewFromCard, function (cardView) {
				cardView.LockMouseUpReveal = isLock;
			});
		};

		SupplyView.prototype.GetNextEndGameAnimation = function () {
			var endGameAnimationState = StorageManager.fetch("EndGameAnimationState");

			if (!endGameAnimationState) {
				endGameAnimationState = {
					animationIndex: 0,
					animationList: this.EndAnimationList
				}
			} else {
				var nextAnimationIndex = endGameAnimationState.animationIndex + 1;

				// if we're at the end of the list, randomize the list and make sure we don't repeat the last
				if (nextAnimationIndex > endGameAnimationState.animationList.length - 1) {
					nextAnimationIndex = 0;
					do {
						endGameAnimationState.animationList.sort(function () {
							Math.random() < 0.5 ? -1 : 1;
						});
					} while (endGameAnimationState.animationList[nextAnimationIndex] == endGameAnimationState.animationList[endGameAnimationState.animationIndex]);
				}

				endGameAnimationState.animationIndex = nextAnimationIndex;
			}

			StorageManager.store("EndGameAnimationState", endGameAnimationState);

			return endGameAnimationState.animationList[endGameAnimationState.animationIndex];
		};

		// choose an ending animation
		SupplyView.prototype.CreateGameEndAnimator = function () {
			var nextAnimation;

			do {
				nextAnimation = this.GetNextEndGameAnimation();
			} while (this.CardSupply.GameName.toLowerCase() == "spider" && nextAnimation == "CardBounceWinAnimator");

			var animation;
			switch (nextAnimation) {
				case "KaleidoscopeWinAnimator":
					animation = new KaleidoscopeWinAnimator(this);
					break;
				case "ButterflyWinAnimator":
					animation = new ButterflyWinAnimator(this);
					break;
				case "FireworksWinAnimator":
					animation = new FireworksWinAnimator(this);
					break;
				case "CardBounceWinAnimator":
					animation = new CardBounceWinAnimator(this);
					break;
			}
			return animation;

		};

		SupplyView.prototype.Dispose = function () {

		};

		Object.defineProperty(SupplyView.prototype, "NavigatableName",
			{
				get: function () {
					return this.Name;
				}
			});

		Object.defineProperty(SupplyView.prototype, "Navigatable",
			{
				get: function () {
					return this._navigatable;
				},
				set: function (value) {
					// TODO
					/*if (!value)
					{
						EngineManagers.Gui.NavigationController.RemoveNavigatable(this);
					}
					else
					{
						EngineManagers.Gui.NavigationController.AddNavigatable(this);
					}*/

					this._navigatable = value;
				}
			});

		Object.defineProperty(SupplyView.prototype, "NavigatableVisibility",
			{
				get: function () {
					return this.Visible;
				},
				set: function (value) {
					this.Visible = value;
				}
			});


		Object.defineProperty(SupplyView.prototype, "Focused",
			{
				get: function () {
					return this._focused;
				},
				set: function (value) {
					if (this._focused == value) {
						return;
					}

					// TODO
					/*if (value)
					{
						EngineManagers.Input.KeyDown += FocusedStateAction;
					}
					else
					{
						EngineManagers.Input.KeyDown -= FocusedStateAction;
					}
					*/
					this._focused = value;
					this.OnChangedFocus();

				}
			});

		SupplyView.prototype.FocusedStateAction = function (keyboardEvent) {

		};

		SupplyView.prototype.DeactivateInputAndNavigation = function () {
			this.InputEnabled = false;
			this.GameInputInterpreter.InputEnabled = false;
			this.Navigatable = false;
			// TODO
			//EngineManagers.Input.KeyDown -= PressKey;
			//EngineManagers.Input.KeyUp -= ReleaseKey;
		};

		SupplyView.prototype.ActivateInputAndNavigation = function () {
			this.DeactivateInputAndNavigation();
			this.InputEnabled = true;
			this.GameInputInterpreter.InputEnabled = true;
			this.Navigatable = true;
			// TODO
			//EngineManagers.Input.KeyDown += PressKey;
			//EngineManagers.Input.KeyUp += ReleaseKey;
		};

		SupplyView.prototype.setActiveLastCard = function (fanLimit) {
			var pileView = this.GetPileView('Waste');
			if (this.KeyboardFocus) {
				if (pileView.Pile.Cards.length) {
					this.GameInputInterpreter.removeHighlightedCard();
					this.ClearHints();
					pileView.FanLimit = fanLimit;
					this.KeyboardFocus.Keyboard.GetKeyboardFocus();
				} else {
					this.KeyboardFocus.Keyboard.LoseKeyboardFocus();
					this.KeyboardFocus = this.GetPileView('Stock');
					this.KeyboardFocus.Keyboard.GetKeyboardFocus();
				}
			}

		};

        SupplyView.prototype.playDealSound = function () {
            if (!this.dealSoundIsAllowed) return;
			var delay = 0, soundName = "Deal_Klondike";
			switch (this.CardSupply.GameName) {
				case "Klondike":
					soundName = "Deal_Klondike";
					delay = 600;
					break;
				case "Spider":
					soundName = "Deal_Spider_Draw";
					delay = 400;
					break;
				case "FreeCell":
					soundName = "Deal_FreeCell";
					delay = 400;
					break;
				case "Pyramid":
					soundName = "Deal_Pyramid";
					delay = 700;
					break;
				case "TriPeaks":
					soundName = "Deal_TriPeaks";
					delay = 50;
					break;
			}
			setTimeout(function () {
				EngineManagers.Sounds.PlaySound(soundName);
			}.bind(this), delay);
		};

		SupplyView.prototype.getModeSpecificDimensions = function () {
			var width = 200, height = 200;
			switch (this.CardSupply.GameName) {
				case "Klondike":
					width = 1300;
					height = 1000;
					break;
				case "Spider":
					width = 1640;
					height = 1010;
					break;
				case "FreeCell":
					width = 1620;
					height = 1070;
					break;
				case "Pyramid":
					width = 1450;
					height = 1050;
					break;
				case "TriPeaks":
					width = 1650;
					height = 1050;
			}
			return {width: Absolute.Coords.x(width), height: Absolute.Coords.y(height)};
		};

		SupplyView.prototype.getModeSpecificOffset = function () {
			var x = 200, y = 200;
			switch (this.CardSupply.GameName) {
				case "Klondike":
					x = 0;
					y = -30;
					break;
				case "Spider":
					x = 0;
					y = -30;
					break;
				case "FreeCell":
					x = 0;
					y = -60;
					break;
				case "Pyramid":
					x = 0;
					y = -40;
					break;
				case "TriPeaks":
					x = 0;
					y = -40;
			}
			return {x: Absolute.Coords.x(x), y: Absolute.Coords.y(y)};
		};

		SupplyView.prototype.setUpPileUpdate = function (isShortUpdate) {
			// fixes a FreeCell-specific bug : cards being rendered on top of each other rarely
			if (this.hasBeenDestroyed) return;
			clearTimeout(this.pileUpdateInterval);
			clearTimeout(this.pileUpdateTimeout);
			if (this.CardSupply.GameName === "FreeCell") {
				this.pileUpdateInterval = setInterval(function () {
					this.OnMoveCards();
				}.bind(this), 100);
				this.pileUpdateTimeout = setTimeout(function () {
					clearInterval(this.pileUpdateInterval);
				}.bind(this), ((isShortUpdate) ? 500 : 4000));
			}
		};

		SupplyView.prototype.handleWindowFocus = function () {
			if (this.hasBeenDestroyed) return;
			if (this.CardSupply && this.CardSupply.GameName === "FreeCell") this.setUpPileUpdate(true);
		};

		return SupplyView;
	});

